import { keysToSnakeCase } from './keysToSnakeCase'

const hasFiles = (obj: unknown) => {
  if (!obj || typeof obj !== 'object') {
    return false
  }

  if (Array.isArray(obj)) {
    for (const item of obj) {
      if (hasFiles(item)) {
        return true
      }
    }
  }

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value: unknown = obj[key as keyof typeof obj]

      if (value instanceof File || value instanceof Blob) {
        return true
      }
      if (typeof value === 'object' && hasFiles(value)) {
        return true
      }
    }
  }

  return false
}

const appendFormData = (formData: FormData, data: any, parentKey = '') => {
  if (data === null || typeof data === 'undefined') {
    return
  }

  if (Array.isArray(data)) {
    data.forEach((item) => {
      appendFormData(formData, item, `${parentKey}[]`)
    })

    return
  }

  if (data !== null && typeof data === 'object' && !(data instanceof File)) {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const value = data[key]
        const newKey = parentKey ? `${parentKey}[${key}]` : key

        appendFormData(formData, value, newKey)
      }
    }

    return
  }

  formData.append(parentKey, data)
}

export const transformRequest = (data: any) => {
  if (data && hasFiles(data)) {
    const formData = new FormData()

    appendFormData(formData, keysToSnakeCase(data))

    return formData
  } else {
    return JSON.stringify(keysToSnakeCase(data))
  }
}
